import { ReactNode } from "react";
import VideoLabel, { RecordingLabelType } from "./VideoLabel";
import styles from "./VideoCard.module.css";

export function VideoCardWrapper({ children }: { children: ReactNode }) {
	return <div className={styles.videoCardWrapper}>{children}</div>;
}

export default function VideoCard({
	type,
	index,
	onClick,
	children,
}: {
	type?: RecordingLabelType;
	index?: number;
	onClick?: () => void;
	children: ReactNode;
}) {
	const label = type ? <VideoLabel type={type} index={index} /> : undefined;

	return (
		<div className={styles.videoCard}>
			{children}
			{onClick ? (
				<button className={styles.videoCardOverlay} onClick={onClick} tabIndex={-1}>
					{label}
				</button>
			) : (
				<div className={styles.videoCardOverlay}>{label}</div>
			)}
		</div>
	);
}
